import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { StyleSheet, css } from 'aphrodite';
import OurismanTravelTheme from '../../ourismanTravelTheme';

export default class Response extends React.Component { // eslint-disable-line
  static propTypes = {
    response: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    active: PropTypes.bool,
  }

  static defaultProps = {
    active: false,
  }

  render() {
    const { response: { id, display, created }, active } = this.props;

    return (<Link
      to={`/forms/responses/${id}/`}
      className={active ? css(styles.active) : undefined}
    >
      <div className={css(styles.listItem)}>
        <span className={css(styles.listDisplayName)}>{display}</span>
        <span className={css(styles.timestamp)}>{moment(created).format('MMMM Do YYYY, h:mm:ss a')}</span>
      </div>
    </Link>);
  }
}

const styles = StyleSheet.create({
  listItem: {
    borderBottom: `1px solid ${OurismanTravelTheme.palette.borderColor}`,
    color: OurismanTravelTheme.palette.textColor,
    display: 'flex',
    flexDirection: 'column',
    fontSize: '14px',
    padding: '5px',
  },
  listDisplayName: {
    fontWeight: 'bold',
  },
  timestamp: {
    fontSize: 10,
  },
  active: {
    background: OurismanTravelTheme.palette.accent2Color,
    borderRight: `5px solid ${OurismanTravelTheme.palette.accent3Color}`,
    boxSizing: 'border-box',
    display: 'inline-block',
    width: '100%',
  },
});



// WEBPACK FOOTER //
// /src/components/Forms/Response.js